import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "./api";
import { BRAND } from "./brand";

const Ctx = createContext(null);
export const usePanel = () => useContext(Ctx);

export function PanelProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = verificando, null = sin sesion
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(BRAND.themeKey) || "light"; } catch { return "light"; }
  });

  useEffect(() => {
    if (!getToken()) { setUser(null); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch((e) => {
      if (e?.response?.status === 401) setToken("");
      setUser(e?.response?.status === 401 ? null : false);
    });
  }, []);

  useEffect(() => { try { localStorage.setItem(BRAND.themeKey, theme); } catch { /* noop */ } }, [theme]);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);
  const logout = useCallback(() => { setToken(""); setUser(null); }, []);
  const toggleTheme = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);

  return <Ctx.Provider value={{ user, login, logout, theme, toggleTheme }}>{children}</Ctx.Provider>;
}
